import { render, staticRenderFns } from "./YouthCertificationForm.vue?vue&type=template&id=46234303&scoped=true&"
import script from "./YouthCertificationForm.vue?vue&type=script&lang=js&"
export * from "./YouthCertificationForm.vue?vue&type=script&lang=js&"
import style0 from "./YouthCertificationForm.vue?vue&type=style&index=0&id=46234303&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46234303",
  null
  
)

export default component.exports